import axios from 'axios'

export class Rettungspunkte{
    static async get(){
        try {
            const response = await axios.get(
                'https://feuerwehr-server.org:5000/rettungspunkte'
            );

            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    }
}
